import { PublicEvents } from "../types/Events.types";
import { processEvent } from "../services/processEvent.service";
/**
 * Analytics Api: adImpressionEvent.
 * @param {object} AdImpressionEventParams Object with the ad impression event details.
 * @param {string} AdImpressionEventParams.advertisementId Advertisement Identifier.
 * @param {string} AdImpressionEventParams.advertisementMidasId Midas Id for the Ad
 * @param {string} AdImpressionEventParams.advertisementPageId Page Id for the Ad.
 * @param {string} AdImpressionEventParams.advertisementPlacementId Placement Id for the Ad.
 * @param {string} [AdImpressionEventParams.variations] Ad variations
 * @param {object} [customPayload] An optional payload that may be provided to send additional data with the event.
 *
 * @example
 * import { adImpressionEvent } from "@octagon/public-analytics";
 *
 * // With NO additional payload data
 * adImpressionEvent({
 *   advertisementId: "T_60606",
 *   advertisementMidasId: "-4105642068303810509_tile2_T_60606",
 *   advertisementPageId: "chasehome_3",
 *   advertisementPlacementId: "tile2",
 *   variations: "tileSecondaryImgId:default"
 * });
 *
 * // With additional payload data
 * adImpressionEvent(
 *   {
 *     advertisementId: "T_60606",
 *     advertisementMidasId: "-4105642068303810509_tile2_T_60606",
 *     advertisementPageId: "chasehome_3",
 *     advertisementPlacementId: "tile2",
 *     variations: "tileSecondaryImgId:default"
 *   },
 *   { devSpecifiedData: "1625254612928" }
 * );
 *
 * @category Events
 */
export function adImpressionEvent(params, customPayload) {
    if (customPayload === void 0) { customPayload = {}; }
    processEvent(PublicEvents.AD_IMPRESSION, params, customPayload);
}
